<script setup>
import FormContainer from "@/Pages/Components/FormContainer.vue";
import { usePage } from "@inertiajs/vue3";
import axios from 'axios';
import { ref } from "vue";

const { form } = defineProps({
    form: {
        type: Object,
        default: {}
    }
})

let { providedLocalAuthority, localAuthorities, isLAReferral } = usePage().props;

const blankLA = {
    id: -1,
    name: 'Not Sure',
}

let filteredLocalAuthorities = ref(localAuthorities);
let selectReadonly = ref(false);

const getLocalAuthoritiesWithinPostcode = () => {
    const postCode = form.postcode;
    if (!postCode) {
        filteredLocalAuthorities.value = localAuthorities;
    } else {
        let postcodeNoSpaces = postCode.replace(' ', '');
        let filteredLocalAuthoritiesByPostcode = localAuthorities;

        if (postcodeNoSpaces.length >= 6) {
            selectReadonly.value = true;
            axios.get(route('form.fetch-local-authorities-for-postcode'), {
                params: {
                    postcode: postCode,
                }
            }).then(response => {
                const matchingExactPostCodes = response.data.exact_post_codes;

                const matchingIds = matchingExactPostCodes.map((exact) => exact.local_authority_id);
                filteredLocalAuthoritiesByPostcode = filteredLocalAuthoritiesByPostcode.filter(authority => matchingIds.includes(authority.portal_la_id));

                if (matchingExactPostCodes.length > 0) {
                    form.home_local_authority_id = matchingExactPostCodes[0].local_authority_id;
                }
                filteredLocalAuthorities.value = filteredLocalAuthoritiesByPostcode;
                selectReadonly.value = false;
            }).catch(() => {
                filteredLocalAuthorities.value = localAuthorities;
                selectReadonly.value = false;
            });
        } else {
            filteredLocalAuthorities.value = [];
        }
    }
}

</script>

<template>
    <FormContainer title="Location">
        <v-row>
            <v-col cols="12">
                <p class="mb-3">
                    <small v-if="!isLAReferral" tabindex="0">
                        You can foster for any local authority within 20 miles of your home.
                        Please enter your postcode and select your preferred option from the list below.
                        If you are unsure who you would like to foster with, please select ‘Not sure’
                    </small>
                    <small v-else tabindex="0">
                        Please enter your postcode
                    </small>
                </p>
                <v-text-field @input="getLocalAuthoritiesWithinPostcode()" v-model="form.postcode" :error-messages="form.errors.postcode" label="Postcode*" aria-label="Postcode*" aria-required="true"/>
            </v-col>
            <v-col cols="12" v-if="!providedLocalAuthority">
                <v-select
                    v-model="form.localAuthority"
                    label="Local Authority*"
                    aria-label="Select Local Authority*"
                    :items="filteredLocalAuthorities.concat(blankLA)"
                    item-value="portal_la_id"
                    item-title="name"
                    :error-messages="form.errors.localAuthority"
                    aria-required="true"
                    role="option"
                    :disabled="selectReadonly"
                />
            </v-col>
        </v-row>
    </FormContainer>
</template>

<style scoped>

</style>
